@if (!loading) {
  <div class="downloads-metrics margin-top-md margin-bottom-md">
    <h2 class="portal-section-title">
      {{'research.portal.country.downloads' | translate}}
    </h2>
    <mulo-world-map
      baseColor="#cdcdcd"
      [countriesColors]="countriesColors"
      [focusCountry]="countryInFocus"
      (svgReady)="isSvnReady.next(true)"
      [static]="true"
    ></mulo-world-map>
    <div (deferLoad)="showMetricsDownloads = true"></div>
    @if (showMetricsDownloads) {
      <div class="metrics-wrapper">
        <esp-download-map-datatable
          [downloadsByCountry]="downloadsByCountry"
        ></esp-download-map-datatable>
        @if (mapReady) {
          <esp-portal-metrics
            metric="downloads"
            [show]="showMetricsDownloads"
            (focus)="onMetricFocus($event)"
            [downloadsByCountry]="downloadsByCountry"
            style="height: 100%;"
            >
          </esp-portal-metrics>
        }
      </div>
    }
  </div>
}
